<template>
  <div>
    <div id="menu">
      <div class="primeiro-menu">
        <router-link to="/home">
          <span id="logo-home"></span>
        </router-link>
      </div>
      <div class="segundo-menu">
        <span
          class="btn-toggle"
          @click="abrirMenu(estadoMenu)"
        ></span>
        <ul>
          <li
            v-for="item in listaMenu"
            :key="item.id"
            @click="atualizarModal(item.id)"
          >
            <router-link :to="item.rota">{{ item.nome }}</router-link>
          </li>
        </ul>
      </div>
      <div class="terceiro-menu">
        <div class="terceiro-menu-esquerdo">
          <p>PDF:</p>
          <div class="bandeiras">
            
            <a href="http://arquivos.ana.gov.br/pnsh/pnsh.pdf" target="_blank">
              <img src="@/assets/brasil.svg"> 
            </a>
            <a href="/pdf/ingles.pdf" target="_blank">
              <img src="@/assets/england.svg">
            </a>
            <a href="/pdf/espanhol.pdf" target="_blank">
              <img src="@/assets/espanha.svg">
            </a>
          </div>

         
        </div>
        <div class="terceiro-menu-direito">
          <ul>
            <li>
                <a href="https://www.facebook.com/anagovbr/" target="_blank">
                    link
                </a>
            </li>
            <li>
                <a href="https://www.linkedin.com/company/anagovbr/" target="_blank">
                  link
              </a>
            </li>
            <li>
               <a href="https://twitter.com/ANAgovbr" target="_blank">
                  link
              </a>
            </li>
            <li>
                <a href="https://www.instagram.com/anagovbr/" target="_blank">
                  link
                </a>
            </li>
            <li>
                <a href="https://www.youtube.com/channel/UCLLjIf0AjdwQAtp3hDmrhZQ" target="_blank">
                  link
                </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Sidebar-Component />
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Sidebar from '@/components/Sidebar'


export default {

  components: {
    'Sidebar-Component': Sidebar
  },

  data () {
    return {
      listaMenu: [
        {
          id: 1,
          nome: 'O Índice de Segurança Hídrica (ISH)',
          rota: 'seguranca'
        },
        {
          id: 2,
          nome: 'A Construção',
          rota: 'construcao'
        },
        {
          id: 3,
          nome: '',
          rota: ''
        },
        {
          id: 4,
          nome: 'O Programa',
          rota: 'programa'
        },
        {
          id: 5,
          nome: 'As Intervenções',
          rota: 'intervencao'
        },
        {
          id: 6,
          nome: 'O Monitoramento',
          rota: 'monitoramento'
        }
      ]
    }
  },

  computed: {
    ...mapState({
      estadoMenu: (state) => state.Layout.menu
    })
  },

  methods: {
    ...mapActions({
      setModal: 'Layout/setModalAtiva',
      toggleMenu: 'Layout/toggleMenu'
    }),

    atualizarModal (item) {
      this.setModal(item)
    },

    abrirMenu (estado) {
      this.toggleMenu(!estado)
    }
  }

};
</script>


<style lang="scss" scoped>
.bandeiras {
  display: flex;
  align-content: center;
  justify-content: center;
  img {
    padding-left: 20px;
  }
}
#menu {
  position: relative;
  height: get-vh(130px);
  z-index: 4;
  .primeiro-menu {
    background-image: url(../assets/menu.svg);
    background-repeat: no-repeat;
    background-size: contain;
    height: 50px;
    top: 0px;
    right: 0;
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    width: 1235px;

    @include media_tablet() {
      display: none;
    }

    #logo-home {
      cursor: pointer;
      background-image: url(../assets/icon_home.png);
      height: 22px;
      position: absolute;
      top: 10px;
      left: 46px;
      width: 25px;

      &:hover {
        filter: contrast(60%);
        transition: all 500ms linear;
      }
    }
  }

  .segundo-menu {
    display: flex;
    justify-content: space-between;
    background-image: url(../assets/sub-menu.svg);
    background-repeat: no-repeat;
    background-size: contain;
    height: 50px;
    position: fixed;
    top: 11px;
    right: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 1069px;
    z-index: 1;

    @include media_tablet() {
      display: flex;
      justify-content: center;
      background-image: none;
      background-color: #8fc74a;
      top: 0px;
      width: 100%;
      position: absolute;
    }

    .btn-toggle {
      display: none;
      @include media_tablet() {
        display: block;
        background-image: url(../assets/btn-menu.svg);
        height: 21px;
        width: 24px;
        margin: 0 auto 0 0;
        position: absolute;
        top: 12px;
        left: 15px;
        display: block;
      }
    }

    ul {
      display: flex;
      align-items: center;
      padding: 0 30px;
      li {
        cursor: pointer;
        color: #344789;
        font-size: 14px;

        &:nth-child(1) {
          margin-right: 17px;
          @include media_tablet() {
            display: none;
          }
        }
        &:nth-child(2) {
          margin-right: 17px;
          @include media_tablet() {
            display: none;
          }
        }
        &:nth-child(3) {
            background-image: url(../assets/logopnh.jpg);
            background-size: 80%;
            background-repeat: no-repeat;
            background-color: #fff;
            color: transparent;
            pointer-events: none;
            width: 276px;
            height: 135px;
            margin-top: 50px;
            background-position: center center;
            box-shadow: 0 2px 44px 0 rgba(0, 0, 0, 0.5);
            border-radius: 0 0 20px 20px;
          @include media_tablet() {
            background-image: url(../assets/logopnh.jpg);
            background-repeat: no-repeat;
            background-size: 80%;
            background-color: #fff;
            width: 205px;
            height: 90px;
            border-radius: 0 0 20px 20px;
            margin-top: 40px;
          }
        }
        &:nth-child(4) {
          margin-left: 17px;
          @include media_tablet() {
            display: none;
          }
        }
        &:nth-child(5) {
          margin-left: 17px;

          @include media_tablet() {
            display: none;
          }
        }
        &:nth-child(6) {
          margin-left: 17px;

          @include media_tablet() {
            display: none;
          }
        }
      }
    }
  }

  .terceiro-menu {
    display: flex;
    justify-content: space-between;
    background-image: url(../assets/terceiro-menu.svg);
    background-repeat: no-repeat;
    border-radius: 0px 0px 10px 10px;
    background-size: contain;
    height: 50px;
    position: fixed;
    top: 57px;
    right: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 853px;

    @include media_tablet() {
      display: none;
    }

    .terceiro-menu-esquerdo {
      display: flex;
      align-items: center;
      width: 50%;
      height: 100%;
      padding-left: 40px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: 24px;
        top: 16px;
        background-repeat: no-repeat;
        height: 15px;
        width: 12px;
      }

      p {
        color: #fff;
        font-family: "rubik_medium";

        &:hover {
            color: #8fc74a;
            transition: all 200ms ease-in;
        }
      }
    }
    .terceiro-menu-direito {
      display: flex;
      justify-content: center;
      width: 50%;

      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 240px;
        padding-left: 60px;

        li {
          cursor: pointer;

          a {
              color: transparent;
          }
          &:nth-child(1) {
            background-image: url(../assets/icon-face.png);
            width: 22px;
            height: 22px;
          }
          &:nth-child(2) {
            background-image: url(../assets/icon_link.png);
            width: 22px;
            height: 22px;

          }
          &:nth-child(3) {
            background-image: url(../assets/icon_twitter.png);
            width: 22px;
            height: 22px;
          }
          &:nth-child(4) {
            background-image: url(../assets/icon_instagram.png);
            width: 22px;
            height: 22px;
          }
          &:nth-child(5) {
            background-image: url(../assets/you.png);
            width: 22px;
            height: 22px;
          }
        }
      }
    }
  }
}

.router-link-exact-active {
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}
</style>
